/**
 * External dependencies
 */

import React from 'react';

/**
 * DWT dependencies
 */
import {
  handleAudioContributors,
  handleBookAuthors,
  handleBookCoverImage,
  handleBookReadMoreURL,
  isEncoded,
} from '../utils/component-utils';

/**
 * BookModalMain
 *
 * Book main content for modal
 *
 * @param {Object} props
 * @param {Object} props.context
 * @param {Object} props.modalData
 */

const BookModalMain = ({ context, modalData }) => {
  const allowed =
        context?.featureBy === 'books'
          ? JSON.parse( context.allowedMetadataFields )
          : null;
  const bookCoverStyle = window?.DP?.book_cover_background;
  const isAudio = bookCoverStyle === 'Audio';

  const getCoverImage = handleBookCoverImage( modalData, context?.entry );
  const getAuthors = handleBookAuthors( modalData, context?.entry );
  const getAudioContributors = handleAudioContributors( modalData, context?.entry === 'automatic' );
  const getDescription =
        context?.entry === 'automatic'
          ? modalData?.flapCopy
          : decodeURIComponent( modalData?.description );
  const getReadMoreURL = handleBookReadMoreURL( modalData );
  const getTitle = isEncoded( modalData?.title ) ? modalData.title : encodeURIComponent( modalData.title );

  return (
    <>
      <div className="modal__main">
        <div className="modal__details-view">
          <div className="modal__cover">
            <div className="image-wrapper">
              <div
                className={`api-image-wrapper ${
                  !isAudio
                    ? 'regular-book'
                    : ''
                }`}
              >
                <img
                  className="api-image"
                  src={getCoverImage}
                  alt={`${modalData?.title} by ${decodeURIComponent( getAuthors )}`}
                  data-isbn={
                    modalData?.isbn ? modalData.isbn : null
                  }
                  data-workid={modalData?.workId ?? null}
                  title={modalData?.title ?? null}
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="modal__details md:flex md:basis-3/5 md:flex-col">
            {modalData?.title && allowed.includes( 'Title' ) && (
              <h3 className="modal__heading heading-3 mb-10 mt-0 text-26 text-center">
                <span
                  dangerouslySetInnerHTML={{
                    __html: decodeURIComponent( getTitle )
                  }}
                />
              </h3>
            )}

            {allowed.includes( 'Contributor Name' ) && (
              <>
                {isAudio && getAudioContributors
                  ? (
                    <p className="modal__book-author paragraph-2 mb-0 mt-0 text-center">
                                        By{' '}
                      <strong className="uppercase">
                        {getAudioContributors}
                      </strong>
                    </p>
                  )
                  : (
                    <p className="modal__book-author paragraph-2 mb-0 mt-0 text-center">
                                        By{' '}
                      <strong className="uppercase">
                        {decodeURIComponent( getAuthors )}
                      </strong>
                    </p>
                  )}
              </>
            )}

            {getDescription && (
              <p className="modal__description paragraph-2 font-200">
                <span
                  dangerouslySetInnerHTML={{
                    __html: getDescription
                  }}
                />
                <a
                  className="font-500"
                  href={getReadMoreURL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong>Read more&nbsp;&#62;</strong>
                </a>
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="modal__footer">
        {getReadMoreURL && (
          <a
            className="modal__footer-link"
            href={getReadMoreURL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <strong>View Full Details &#10141;</strong>
          </a>
        )}
      </div>
    </>
  );
};

export default BookModalMain;
